import * as z from 'zod';

import { tcCategoryQuerySchema } from './tc-category-query-schema';

export const tcCategoryUpdateSchema = tcCategoryQuerySchema
  .omit({
    sku_prefix: true,
    terms_conditions_count: true,
  })
  .extend({
    sku_prefix: z.string(),
  });

export type TcCategoryUpdateSchema = z.infer<typeof tcCategoryUpdateSchema>;

export const tcCategoryCreateSchema = tcCategoryUpdateSchema.omit({
  id: true,
});

export type TcCategoryCreateSchema = z.infer<typeof tcCategoryCreateSchema>;
